import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import ServicesPage from './ServicesPage';
import TestPay from './TestPay';
import StripeBankConfirm from './StripeBankConfirm';
import PurchaseConfirmation from './PurchaseConfirmation';
import PurchaseConfirmationMobile from './PurchaseConfirmationMobile';
import ServiceUnavailable from './ServiceUnavailable';
import ContactUs from './ContactUs';
import OfferingsPage from './OfferingsPage';
import Demo from './Demo';
import InvoicesPage from './InvoicesPage';
import GoogleCalendar from './GoogleCalendar';
import VideoPage from './VideoPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Verca landing page */}
        <Route path="/" element={<HomePage />} />
        
        {/* Services page with ID parameter */}
        <Route path="/services/:id" element={<ServicesPage />} />

        <Route path="/invoice/:id" element={<InvoicesPage />} />

        <Route path = "/offerings/:id" element={<OfferingsPage />} />

        <Route path="/testpay" element={<TestPay />} />

        <Route path="/video/:id" element={<VideoPage />} />


        <Route path="/linking-bank" element={<StripeBankConfirm />} />

        <Route path="/google-calendar" element={<GoogleCalendar />} />

        <Route path="/purchase-confirm" element={<PurchaseConfirmation />} />

        <Route path="/service-unavailable" element={<ServiceUnavailable />} />

        <Route path="/purchase-confirm-mobile" element={<PurchaseConfirmationMobile />} />
        <Route path="/demo" element={<Demo />} />

        <Route path="/contact-us" element={<ContactUs />} />
        
        {/* Catch all other routes - redirect to home */}
        {/* <Route path="*" element={<HomePage />} /> */}
      </Routes>
    </Router>
  );
}

export default App;